import { TaskId } from '@business/entities/battle_plan';
import { Endpoint } from '../endpoint';
import { GraphId, CompactGraphResponse } from '@business/entities/graph';
import {
  GraphConditionId,
  GraphConditionRequestParams,
  GraphConditionResponse,
  GraphConditionTaskRequestParams,
  SortConditionTaskQuery,
} from '@business/entities/graph_condition';
import { R } from '@core/utils/r';
import { CompactUserResponse } from '@business/entities/account';

export function fetchGraphConditions(data?: GraphConditionRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphConditionResponse[]>(`@makh/graph-condition`, { params });
}

export function createGraphCondition(data: Partial<GraphConditionResponse>) {
  return Endpoint.post<GraphConditionResponse>(`@makh/graph-condition`, { data });
}

export function fetchGraphCondition(id: GraphConditionId) {
  return Endpoint.get<GraphConditionResponse>(`@makh/graph-condition/graph-condition/${id}`);
}

export function updateGraphCondition(graphId: GraphId, data: Partial<GraphConditionResponse>) {
  return Endpoint.patch<GraphConditionResponse>(`@makh/graph-condition/${graphId}`, { data });
}

export function deleteGraphCondition(id: GraphConditionId) {
  return Endpoint.delete<GraphConditionResponse[]>(`@makh/graph-condition/${id}`);
}

export function fetchGraphs() {
  return Endpoint.get<CompactGraphResponse[]>(`@makh/graph-condition/graphs`);
}

export function createTask(id: GraphConditionId, data: GraphConditionTaskRequestParams) {
  return Endpoint.post<GraphConditionResponse>(`@makh/graph-condition/create-task/${id}`, { data });
}

export function updateConditionValue(id: GraphConditionId, data: any) {
  return Endpoint.post<GraphConditionResponse>(`@makh/graph-condition/update-condition-value/${id}`, { data });
}

export function sortTasks(id: GraphConditionId, data: SortConditionTaskQuery) {
  return Endpoint.post<GraphConditionResponse>(`@makh/graph-condition/sort-tasks/${id}`, { data });
}

export function deleteTask(id: TaskId) {
  return Endpoint.delete<GraphConditionResponse>(`@makh/graph-condition/task/${id}`);
}

export function fetchUsers() {
  return Endpoint.get<CompactUserResponse[]>(`@makh/graph-condition/users`);
}
